import React, { useState, useEffect, useRef, memo, forwardRef } from "react";
import { PurityApi } from "../../api/PurityApi.js";
import { getAddToCart, getBranchId } from "utility/HeaderConfig.js";
import { Link } from "react-router-dom";
import CategorysMenu from "./CategorysMenu.js"; // used in mobile menu only
import logo from "../../images/EswarLogo.png";
import { useCartContext } from "context/UseCartContext.js";
import toast, { Toaster } from "react-hot-toast";
import { reactLocalStorage } from "reactjs-localstorage";
import Noimg from "../../images/no_img.jpg";
import RemoveCart from "components/RemoveCart.js";
import { getProduct } from "api/ProductApi.js";
import moment from "moment";
import { beforeCreatedAtData, filterFormatFromDate, filterFormatToDate } from "utility/Constant.js";
import TopbarMenus from "./TopbarMenus.js";

function useAutoScroll(enabled, speed = 1) {
  useEffect(() => {
    if (!enabled) return;
    let animId;
    const step = () => { window.scrollBy(0, speed); animId = requestAnimationFrame(step); };
    animId = requestAnimationFrame(step);
    return () => cancelAnimationFrame(animId);
  }, [enabled, speed]);
}

const MyComponent = ({ branch }) => {
  const [recentGoldRate, setRecentGoldRate] = useState({ metaProdTypeName: "Gold", rate: "N/A", unitType: "", purity: "" });
  const [recentGold18Rate, setRecentGold18Rate] = useState({ metaProdTypeName: "Gold", rate: "N/A", unitType: "", purity: "" });
  const [recentSilverRate, setRecentSilverRate] = useState({ metaProdTypeName: "Silver", rate: "N/A", unitType: "" });
  const [viewCart, setViewCart] = useState([]);
  const [total, setTotal] = useState(0);
  const [showModal, setShowModal] = useState("");
  const [cartOpen, setCartOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [autoScrollOn, setAutoScrollOn] = useState(false);
  const cartRef = useRef(null);

  useAutoScroll(autoScrollOn, 3);
  const { data, branchId, dispatch } = useCartContext();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const handler = (e) => { if (cartRef.current && !cartRef.current.contains(e.target)) setCartOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  useEffect(() => { getProductRate(); }, []);

  const getProductRate = async () => {
    const fromDate = moment().startOf("day").format("YYYY-MM-DD HH:mm:ss");
    const toDate = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
    const filterData = { branch: getBranchId(), createdAtFrom: filterFormatFromDate(fromDate), createdAtTo: filterFormatToDate(toDate) };
    const todayMetalRate = await PurityApi(filterData);
    if (todayMetalRate.errorCode === undefined) {
      let gf = false, g18f = false, sf = false;
      todayMetalRate.response.forEach((item) => {
        const n = item.metaProdTypeName?.toLowerCase();
        if (n === "gold" && item.purity?.includes("22") && !gf) { item.purity = "22K"; setRecentGoldRate(item); gf = true; }
        else if (n === "gold" && item.purity?.includes("18") && !g18f) { const i18 = {...item, purity: "18K"}; setRecentGold18Rate(i18); g18f = true; }
        else if (n === "silver" && !sf) { setRecentSilverRate(item); sf = true; }
      });
    }
  };

  useEffect(() => { viewCartList(); }, [data, branchId]);

  const viewCartList = () => {
    const newArray = getAddToCart() ? JSON.parse(getAddToCart()).filter((c) => c.branchId === getBranchId()) : [];
    if (newArray.length === 0) { setViewCart([]); setTotal(0); return; }
    let dataList = [];
    newArray.forEach((element, index) => {
      getProduct(10, { branch: getBranchId(), id: element.id, beforeCreatedAt: beforeCreatedAtData }).then(() => {
        dataList.push(element);
        if (dataList.length - 1 === index) {
          setTotal(newArray.reduce((a, i) => a + Math.trunc(i.total || 0), 0));
          setViewCart([...dataList]);
        }
      });
    });
  };

  const removeItemFromCart = (code) => {
    const result = JSON.parse(getAddToCart()).filter((i) => i.productCode !== code);
    reactLocalStorage.set("CartList", JSON.stringify(result));
    dispatch({ type: "ADD", payload: result });
    setTotal(result.reduce((a, i) => a + Math.trunc(i.total || 0), 0));
    setViewCart(result);
    toast.success("Removed from bag", { duration: 2000, position: "top-right", style: { background: "#1a1a1a", color: "#fff", borderRadius: "10px", fontSize: "13px" } });
    setShowModal("");
  };

  const cartCount = data?.filter((c) => c.branch === getBranchId())?.length || JSON.parse(getAddToCart() || "[]").length;

  const fmtGold = (r) => {
    const v = r.onlineRate > 0 ? r.onlineRate : r.rate;
    if (!v || v === "N/A") return "N/A";
    return `₹${v}${r.unitType ? `/${r.unitType}` : ""}${r.purity ? ` (${r.purity})` : ""}`;
  };
  const fmtSilver = (r) => {
    const v = r.onlineRate > 0 ? r.onlineRate : r.rate;
    if (!v || v === "N/A") return "N/A";
    return `₹${v}${r.unitType ? `/${r.unitType}` : ""}`;
  };

  return (
    <>
      <Toaster position="top-right" containerStyle={{ zIndex: 999999 }} />

      <header>
        <nav
          aria-label="Main navigation"
          style={{
            position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000,
            background: "rgba(255,255,255,0.97)",
            backdropFilter: "saturate(180%) blur(20px)",
            WebkitBackdropFilter: "saturate(180%) blur(20px)",
            borderBottom: scrolled ? "1px solid #e5e5ea" : "1px solid transparent",
            boxShadow: scrolled ? "0 1px 16px rgba(0,0,0,0.07)" : "none",
            transition: "border-color 0.24s, box-shadow 0.24s",
            overflow: "visible",
          }}>
          <div style={{ maxWidth: 1440, margin: "0 auto", padding: "0 16px", height: 72, display: "grid", gridTemplateColumns: "auto 1fr auto", alignItems: "center", gap: 8 }}>

            {/* Logo + Hamburger */}
            <div style={{ display: "flex", alignItems: "center", gap: 6, flexShrink: 0 }}>
              <button
                onClick={() => setMobileMenuOpen((v) => !v)}
                aria-label={mobileMenuOpen ? "Close navigation menu" : "Open navigation menu"}
                aria-expanded={mobileMenuOpen}
                aria-controls="mobile-nav-menu"
                style={{ display: "none", alignItems: "center", justifyContent: "center", width: 44, height: 44, padding: 7, background: "none", border: "none", borderRadius: 8, color: "#1c1c1e", cursor: "pointer", flexShrink: 0 }}
                className="ej-hamburger-btn">
                {mobileMenuOpen
                  ? <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                  : <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>}
              </button>

              <Link to="/" style={{ flexShrink: 0, textDecoration: "none", display: "flex", alignItems: "center", gap: 10 }} aria-label="Eswar Jewellers — Home">
                <div className="ej-logo-img" style={{ width: 120, height: 72, borderRadius: 14, border: "2px solid #e8c96a", boxShadow: "0 2px 8px rgba(200,150,12,0.25)", flexShrink: 0, background: "#fff", display: "flex", alignItems: "center", justifyContent: "center", overflow: "visible", padding: "4px 6px", position: "relative" }}>
                  <img
                    src={logo}
                    alt="Eswar Jewellers Logo"
                    className="ej-logo-img-tag"
                    style={{ width: "100%", height: "auto", objectFit: "contain", objectPosition: "top center", display: "block", position: "relative", top: 0 }}
                  />
                </div>
              </Link>
            </div>

            {/* Desktop Category Menu moved below hero - empty spacer keeps grid intact */}
            <div className="ej-desktop-nav-wrap" />

            {/* Right controls */}
            <div style={{ display: "flex", alignItems: "center", gap: 4, flexShrink: 0, justifyContent: "flex-end" }}>

              {/* Metal rates */}
              <div
                style={{ display: "flex", alignItems: "stretch", gap: 0, background: "linear-gradient(135deg,#fdf8ee,#fff9f0)", border: "1.5px solid #e8c96a", borderRadius: 12, overflow: "hidden", boxShadow: "0 2px 8px rgba(200,150,12,0.10)" }}
                className="ej-rates-badge"
                aria-label="Today's metal rates"
                role="region"
              >
                <div style={{ display: "flex", alignItems: "center", gap: 7, padding: "7px 10px" }}>
                  <div style={{ width: 26, height: 26, borderRadius: "50%", background: "linear-gradient(135deg,#f5c842,#c9890f)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, boxShadow: "0 1px 4px rgba(200,140,12,0.35)" }} aria-hidden="true">
                    <span style={{ color: "#fff", fontSize: 8, fontWeight: 900, letterSpacing: "-.3px" }}>GOLD</span>
                  </div>
                  <div style={{ lineHeight: 1.25 }}>
                    <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: ".1em", textTransform: "uppercase", color: "#6c6c70" }}>Gold 22K</div>
                    <div style={{ fontSize: 12, fontWeight: 900, color: "#1c1c1e", whiteSpace: "nowrap" }}>{fmtGold(recentGoldRate)}</div>
                  </div>
                </div>
                <div style={{ width: 1, background: "linear-gradient(to bottom,transparent,#e8c96a,transparent)", margin: "6px 0" }} aria-hidden="true" />
                <div className="ej-rate-gold18" style={{ display: "flex", alignItems: "center", gap: 7, padding: "7px 10px" }}>
                  <div style={{ width: 26, height: 26, borderRadius: "50%", background: "linear-gradient(135deg,#f5c842,#9a6f0a)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, boxShadow: "0 1px 4px rgba(200,140,12,0.35)" }} aria-hidden="true">
                    <span style={{ color: "#fff", fontSize: 8, fontWeight: 900, letterSpacing: "-.3px" }}>GOLD</span>
                  </div>
                  <div style={{ lineHeight: 1.25 }}>
                    <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: ".1em", textTransform: "uppercase", color: "#6c6c70" }}>Gold 18K</div>
                    <div style={{ fontSize: 12, fontWeight: 900, color: "#1c1c1e", whiteSpace: "nowrap" }}>{fmtGold(recentGold18Rate)}</div>
                  </div>
                </div>
                <div className="ej-rate-divider-2" style={{ width: 1, background: "linear-gradient(to bottom,transparent,#e8c96a,transparent)", margin: "6px 0" }} aria-hidden="true" />
                <div style={{ display: "flex", alignItems: "center", gap: 7, padding: "7px 10px" }}>
                  <div style={{ width: 26, height: 26, borderRadius: "50%", background: "linear-gradient(135deg,#e0e0e0,#909090)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, boxShadow: "0 1px 4px rgba(0,0,0,0.15)" }} aria-hidden="true">
                    <span style={{ color: "#fff", fontSize: 7, fontWeight: 900, letterSpacing: "-.3px" }}>SILVR</span>
                  </div>
                  <div style={{ lineHeight: 1.25 }}>
                    <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: ".1em", textTransform: "uppercase", color: "#6c6c70" }}>Silver</div>
                    <div style={{ fontSize: 12, fontWeight: 900, color: "#1c1c1e", whiteSpace: "nowrap" }}>{fmtSilver(recentSilverRate)}</div>
                  </div>
                </div>
              </div>

              <TopbarMenus />

              {/* Auto Scroll toggle */}
              
              <button
                onClick={() => setAutoScrollOn((v) => !v)}
                aria-label={autoScrollOn ? "Stop auto scroll" : "Start auto scroll"}
                aria-pressed={autoScrollOn}
                style={{
                  display: "flex", alignItems: "center", gap: 5,
                  padding: "5px 10px", borderRadius: 999,
                  border: `1px solid ${autoScrollOn ? "#d4aa5a" : "#e5e5ea"}`,
                  background: autoScrollOn ? "#faf3d8" : "#f5f5f7",
                  cursor: "pointer", transition: "all .2s",
                  minHeight: 44,
                }}
                className="ej-autoscroll-badge"
              >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={autoScrollOn ? "#b8860b" : "#6c6c70"} strokeWidth="2.5" aria-hidden="true">
                  <polyline points="17 11 12 6 7 11"/><polyline points="17 18 12 13 7 18"/>
                </svg>
                <span style={{ fontSize: 10, fontWeight: 600, color: autoScrollOn ? "#b8860b" : "#6c6c70", letterSpacing: ".04em" }}>
                  {autoScrollOn ? "ON" : "OFF"}
                </span>
                <div style={{ position: "relative", width: 26, height: 14, borderRadius: 999, background: autoScrollOn ? "#b8860b" : "#c7c7cc", flexShrink: 0, transition: "background .2s" }} aria-hidden="true">
                  <span style={{ position: "absolute", top: 2, left: autoScrollOn ? 14 : 2, width: 10, height: 10, borderRadius: "50%", background: "#fff", transition: "left .2s" }} />
                </div>
              </button>
             

              {/* Cart */}
              <div style={{ position: "relative" }} ref={cartRef}>
                <button
                  onClick={() => setCartOpen((v) => !v)}
                  aria-label={`Shopping cart, ${cartCount} ${cartCount === 1 ? "item" : "items"}`}
                  aria-expanded={cartOpen}
                  aria-controls="cart-panel"
                  style={{ position: "relative", display: "flex", alignItems: "center", justifyContent: "center", width: 44, height: 44, background: "none", border: "none", borderRadius: 999, color: "#1c1c1e", cursor: "pointer", transition: "background .14s" }}
                  onMouseEnter={(e) => e.currentTarget.style.background = "#f5f5f5"}
                  onMouseLeave={(e) => e.currentTarget.style.background = "none"}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
                    <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
                    <line x1="3" y1="6" x2="21" y2="6"/>
                    <path d="M16 10a4 4 0 01-8 0"/>
                  </svg>
                  {cartCount > 0 && (
                    <span style={{ position: "absolute", top: 2, right: 2, minWidth: 17, height: 17, padding: "0 4px", background: "#b8860b", color: "#fff", fontSize: 9.5, fontWeight: 700, lineHeight: "17px", borderRadius: 999, textAlign: "center" }} aria-hidden="true">
                      {cartCount}
                    </span>
                  )}
                </button>

                {cartOpen && (
                  <div
                    id="cart-panel"
                    role="dialog"
                    aria-label="Shopping cart"
                    aria-modal="true"
                    style={{ position: "absolute", top: "calc(100% + 12px)", right: 0, width: 360, maxHeight: "80vh", background: "#fff", border: "1px solid #e5e5ea", borderRadius: 20, boxShadow: "0 20px 60px rgba(0,0,0,.15)", overflow: "hidden", display: "flex", flexDirection: "column", animation: "ejScaleIn .2s cubic-bezier(.16,1,.3,1)", zIndex: 9999 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 20px" }}>
                      <h2 style={{ fontFamily: "Cormorant Garamond,Georgia,serif", fontSize: 18, fontWeight: 600, color: "#1c1c1e", margin: 0 }}>Shopping Bag</h2>
                      <span style={{ fontSize: 12, color: "#6c6c70" }}>{cartCount} {cartCount === 1 ? "item" : "items"}</span>
                    </div>
                    <div style={{ height: 1, background: "#f2f2f7", flexShrink: 0 }} />
                    {viewCart.length > 0 ? (
                      <>
                        <div style={{ overflowY: "auto", flex: 1, padding: "10px 16px", display: "flex", flexDirection: "column", gap: 10 }}>
                          {viewCart.map((item, i) => (
                            <div key={i} style={{ display: "flex", gap: 12, padding: 10, borderRadius: 10, background: "#fafafa" }}>
                              <img src={item.images?.includes("@#@") && item.images !== "@#@" ? item.images.split("@#@")[0] : Noimg} alt={item.title || "Product image"} width="62" height="62" style={{ width: 62, height: 62, objectFit: "cover", borderRadius: 8, border: "1px solid #f2f2f7", flexShrink: 0 }} loading="lazy" />
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <p style={{ fontSize: 12.5, fontWeight: 500, color: "#1c1c1e", margin: "0 0 4px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{item.title}</p>
                                <span style={{ display: "block", fontSize: 13.5, fontWeight: 700, color: "#b8860b", marginBottom: 5 }}>₹{Math.trunc(item.total)}</span>
                                <button onClick={() => setShowModal(item.skv)} style={{ fontSize: 11, color: "#6c6c70", background: "none", border: "none", padding: 0, textDecoration: "underline", cursor: "pointer", minHeight: "auto" }} aria-label={`Remove ${item.title} from cart`}>Remove</button>
                              </div>
                            </div>
                          ))}
                        </div>
                        <div style={{ height: 1, background: "#f2f2f7" }} />
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 20px" }}>
                          <span style={{ fontSize: 13.5, fontWeight: 500, color: "#48484a" }}>Subtotal</span>
                          <span style={{ fontSize: 16, fontWeight: 700, color: "#b8860b"}}>₹{Math.trunc(total)}</span>
                        </div>
                        <Link to="/CartPage" onClick={() => setCartOpen(false)}
                          style={{ display: "block", margin: "8px 16px 16px", padding: 12, background: "#1c1c1e", color: "#fff", fontSize: 13, fontWeight: 600, letterSpacing: ".05em", textDecoration: "none", textAlign: "center", borderRadius: 9 }}
                          onMouseEnter={(e) => e.currentTarget.style.background = "#b8860b"}
                          onMouseLeave={(e) => e.currentTarget.style.background = "#1c1c1e"}>
                          View Bag & Checkout
                        </Link>
                      </>
                    ) : (
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "40px 24px", gap: 10, textAlign: "center" }}>
                        <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#d4aa5a" strokeWidth="1.2" aria-hidden="true">
                          <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/>
                        </svg>
                        <p style={{ fontFamily: "Cormorant Garamond,Georgia,serif", fontSize: 18, fontWeight: 500, color: "#1c1c1e", margin: 0 }}>Your bag is empty</p>
                        <Link to="/ProductList" onClick={() => setCartOpen(false)} style={{ fontSize: 12, fontWeight: 600, color: "#b8860b", textDecoration: "none", letterSpacing: ".05em", textTransform: "uppercase", borderBottom: "1px solid #f0ddb0" }}>
                          Explore Collections
                        </Link>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Desktop category nav bar */}
          <div className="ej-catbar-wrapper">
            <CategorysMenu />
          </div>

          {/* Mobile rates strip — visible only on small screens */}
          <div className="ej-mobile-rates-strip">
            <span className="ej-mobile-rate-item">
              <span className="ej-mobile-rate-dot ej-dot-gold22" />
              <span className="ej-mobile-rate-label">Gold 22K</span>
              <span className="ej-mobile-rate-val">{fmtGold(recentGoldRate)}</span>
            </span>
            <span className="ej-mobile-rate-divider" />
            <span className="ej-mobile-rate-item">
              <span className="ej-mobile-rate-dot ej-dot-gold18" />
              <span className="ej-mobile-rate-label">Gold 18K</span>
              <span className="ej-mobile-rate-val">{fmtGold(recentGold18Rate)}</span>
            </span>
            <span className="ej-mobile-rate-divider" />
            <span className="ej-mobile-rate-item">
              <span className="ej-mobile-rate-dot ej-dot-silver" />
              <span className="ej-mobile-rate-label">Silver 90%</span>
              <span className="ej-mobile-rate-val">{fmtSilver(recentSilverRate)}</span>
            </span>
          </div>

          {/* Mobile slide menu */}
          <div
            id="mobile-nav-menu"
            aria-hidden={!mobileMenuOpen}
            style={{ maxHeight: mobileMenuOpen ? "90vh" : 0, overflow: "hidden", transition: "max-height 0.4s cubic-bezier(.16,1,.3,1)", background: "#fff", borderTop: mobileMenuOpen ? "1px solid #f2f2f7" : "none" }}>
            <CategorysMenu isMobile onClose={() => setMobileMenuOpen(false)} />
          </div>
        </nav>
      </header>
      {/* Spacer: 72px logo row + ~48px catbar (catbar hidden on mobile) */}
      <div className="ej-header-spacer" aria-hidden="true" />

      <main id="main-content" tabIndex="-1" style={{ outline: "none" }} />

      {showModal && (
        <>
          <RemoveCart setShowModal={() => setShowModal("")} showModal={showModal} removeItemFromCart={removeItemFromCart} />
          <div style={{ opacity: 0.4, position: "fixed", inset: 0, zIndex: 40, background: "#000" }} aria-hidden="true" />
        </>
      )}

      <style>{`
        @keyframes ejScaleIn { from { opacity:0; transform:scale(.96) translateY(-4px); } to { opacity:1; transform:scale(1) translateY(0); } }

        .ej-catbar-wrapper {
          border-top: 1px solid #ede8d8;
          overflow: visible;
        }

        .ej-header-spacer { height: 120px; }
        @media (max-width: 600px) {
          .ej-header-spacer { height: 148px; }
        }
        @media (min-width: 601px) and (max-width: 820px) {
          .ej-header-spacer { height: 158px; }
        }

        /* ── Mobile rates strip ── */
        .ej-mobile-rates-strip {
          display: none;
          align-items: center;
          gap: 0;
          background: linear-gradient(135deg,#fdf8ee,#fff9f0);
          border-top: 1px solid #f0ddb0;
          padding: 6px 0 6px 12px;
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
          scrollbar-width: none;
          justify-content: flex-start;
        }
        .ej-mobile-rates-strip::-webkit-scrollbar { display: none; }
        @media (max-width: 820px) {
          .ej-mobile-rates-strip { display: flex; }
        }
        @media (min-width: 601px) and (max-width: 820px) {
          .ej-mobile-rates-strip {
            justify-content: center;
            padding: 6px 12px;
          }
        }
        .ej-mobile-rate-item {
          display: flex; align-items: center; gap: 5px;
          padding: 0 10px; white-space: nowrap;
        }
        .ej-mobile-rate-dot {
          width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0;
        }
        .ej-dot-gold22 { background: linear-gradient(135deg,#f5c842,#c9890f); }
        .ej-dot-gold18 { background: linear-gradient(135deg,#f5c842,#9a6f0a); }
        .ej-dot-silver { background: linear-gradient(135deg,#e0e0e0,#909090); }
        .ej-mobile-rate-label {
          font-size: 10px; font-weight: 700; color: #6c6c70;
          letter-spacing: .06em; text-transform: uppercase;
        }
        .ej-mobile-rate-val {
          font-size: 11px; font-weight: 900; color: #1c1c1e;
        }
        .ej-mobile-rate-divider {
          width: 1px; height: 20px; flex-shrink: 0;
          background: linear-gradient(to bottom,transparent,#e8c96a,transparent);
        }

        /* ── Responsive breakpoints ── */

        /* Hide autoscroll below 1100px */
        @media (max-width: 1100px) {
          .ej-autoscroll-badge { display: none !important; }
        }

        /* Hide gold 18K rate below 960px */
        @media (max-width: 960px) {
          .ej-rate-gold18 { display: none !important; }
          .ej-rate-divider-2 { display: none !important; }
        }

        /* Hide full rates badge below 820px */
        @media (max-width: 820px) {
          .ej-rates-badge { display: none !important; }
        }

        /* Hide logo text below 520px */
        @media (max-width: 520px) {
          .ej-logo-text { display: none !important; }
          .ej-logo-img { width: 80px !important; height: 50px !important; border-radius: 10px !important; }
        }

        /* Tablet: slightly smaller logo */
        @media (min-width: 521px) and (max-width: 768px) {
          .ej-logo-img { width: 100px !important; height: 60px !important; }
        }

        /* Mobile: show hamburger, hide catbar */
        @media (max-width: 600px) {
          .ej-desktop-nav-wrap { display: none !important; }
          .ej-hamburger-btn { display: flex !important; }
          .ej-catbar-wrapper { display: none !important; }
        }
        /* Tablet (601-768px): show hamburger + catbar */
        @media (min-width: 601px) and (max-width: 768px) {
          .ej-desktop-nav-wrap { display: none !important; }
          .ej-hamburger-btn { display: flex !important; }
          .ej-catbar-wrapper { display: block !important; }
        }

        .ej-nav-list {
          display: flex !important;
          align-items: center;
          list-style: none;
          margin: 0;
          padding: 0;
          gap: 2px;
          flex-wrap: nowrap;
          overflow: visible;
        }
        .ej-nav-item { flex: 0 1 auto; min-width: 0; overflow: visible; }
        .ej-nav-link { display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
      `}</style>
    </>
  );
};

export default memo(forwardRef(MyComponent));